import { db } from "../firebase-config";
import { collection, query, addDoc, onSnapshot, where, doc, setDoc, deleteDoc } from "firebase/firestore";

export const addAsset = async (organization, asset) => {
    try {
        const docRef = await addDoc(collection(db, "organizations", organization, "assets"), {
            name: asset.name,
            condition: asset.condition,
            serial_number: asset.serial_number,
            employee_id: asset.employee_id,
            purchase_date: asset.purchase_date,
            price: asset.price
        });
        return {
            success: true,
            documentId: docRef.id,
            error: null
        };
    } catch (error) {
        return {
            success: false,
            documentId: null,
            error: error.message || 'Failed to add asset'
        };
    }
};

export const deleteAsset = async (organization, assetId) => {
    try {
        const assetRef = doc(db, "organizations", organization, "assets", assetId);
        await deleteDoc(assetRef);
        return {
            success: true,
            error: null
        };
    } catch (error) {
        return {
            success: false,
            error: error.message || 'Failed to delete asset'
        };
    }
};

export const updateAsset = async (organization, assetId, asset) => {
    try {
        await setDoc(doc(db, "organizations", organization, "assets", assetId), asset, { merge: true });
        return {
            success: true,
            error: null
        };
    } catch (error) {
        return {
            success: false,
            error: error.message || 'Failed to update asset'
        };
    }
};

export const assetsSnapshotListener = (organization, onAssetUpdate) => {
  const assetQuery = query(
      collection(db, "organizations", organization, "assets"),
  );
  const unsubscribe = onSnapshot(assetQuery, (querySnapshot) => {
      const assetItems = [];
      querySnapshot.forEach((doc) => {
          assetItems.push({ id: doc.id, ...doc.data() });
      });
      onAssetUpdate(assetItems);
  });
  return () => unsubscribe();
};

export const assetSnapshotListener = (organization, assetId, onAssetUpdate) => {
  const assetDocRef = doc(db, "organizations", organization, "assets", assetId);

  const unsubscribe = onSnapshot(assetDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
          onAssetUpdate({ id: docSnapshot.id, ...docSnapshot.data() });
      } else {
          onAssetUpdate(null);
      }
  });
  return unsubscribe;
};

export const assetNoteSnapshotListener = (organization, assetId, onNoteUpdate) => {
  const assetNoteQuery = query(collection(db, "organizations", organization, "assets", assetId, "notes"))
  const unsubscribe = onSnapshot(assetNoteQuery, (querySnapshot) => {
      const noteItems = [];
      querySnapshot.forEach((doc) => {
        noteItems.push({ id: doc.id, ...doc.data() });
      });
      onNoteUpdate(noteItems);
  })
  return () => unsubscribe()
}